import React from 'react'
import { user } from 'ampersand-app'
import store from '@/redux/store'

import CsatModal from '@/modules/base/components/csat-modal/csat-modal'
import { csatFeatures, csatFeaturesMapping } from '@/modules/base/components/csat-modal/constants'
import { experimentalFeatures } from '@/modules/base/util/constants'
import moment from 'moment'
import { isString } from 'lodash'
import CsatService from '@/modules/base/components/csat-modal/csatService'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const validateFeature = (feature) => {
  const validationMap = new Map([
    [csatFeatures.analyzeDocument, experimentalFeatures.csatDocuments],
    [csatFeatures.manageFolders, experimentalFeatures.csatDocuments],
    [csatFeatures.setDocumentFilter, experimentalFeatures.csatDocuments],
    [csatFeatures.uploadDocument, experimentalFeatures.csatDocuments],
    [csatFeatures.searchDocuments, experimentalFeatures.csatDocumentsSearch],
    [csatFeatures.createInvoice, null],
  ])

  const experimentalFeature = validationMap.get(feature)
  return experimentalFeature
    ? user.experimentalFeatures.includes(experimentalFeature)
    : true
}

const checkTrackingIsDone = (csatTrackings, feature, openAfterCount) => {
  return csatTrackings.find((item) => {
    if (isString(item)) {
      return item === csatFeaturesMapping[feature]
    }

    const { showAgainAt, openAfterCountFulfilled } = item

    if (openAfterCount && !openAfterCountFulfilled) {
      return false
    }

    return item.feature === csatFeaturesMapping[feature] && (!showAgainAt || moment().isBefore(showAgainAt))
  })
}

/**
 *
 * @param {{feature: string, openAfterCount?}} param0
 * @returns
 */
const openCsatModal = ({ feature, openAfterCount }) => {
  const { user: { info: { csatTrackings } } } = store.getState()
  const isValid = validateFeature(feature)

  if (!isValid) return null

  if (openAfterCount) {
    const found = csatTrackings.find((item) => item.feature === csatFeaturesMapping[feature])
    if (!found || (!found.openAfterCountFulfilled && (found.usedCount ?? 0) < openAfterCount)) {
      CsatService.updateStoredFeatures({ feature, openAfterCount })
      return true
    }
  }

  if (checkTrackingIsDone(csatTrackings, feature, openAfterCount)) {
    return true
  }

  const getComponent = (onClose) => (
    <CsatModal
      open
      feature={feature}
      openAfterCount={openAfterCount}
      onClose={onClose}
    />
  )

  renderElement(getComponent)
}

export default openCsatModal
